var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1019_131275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6.94727,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 52.0675C39.55 52.0675 39.1 51.9625 38.725 51.7525C35.92 50.2225 30.985 48.6025 27.895 48.1975L27.46 48.1375C25.495 47.8975 23.875 46.0525 23.875 44.0575V25.9375C23.875 24.7525 24.34 23.6725 25.195 22.8925C26.05 22.1125 27.16 21.7375 28.33 21.8425C31.63 22.0975 36.61 23.7475 39.43 25.5175L39.79 25.7275C39.895 25.7875 40.12 25.7875 40.21 25.7425L40.45 25.5925C43.27 23.8225 48.25 22.1425 51.565 21.8575C51.595 21.8575 51.715 21.8575 51.745 21.8575C52.84 21.7525 53.965 22.1425 54.805 22.9225C55.66 23.7025 56.125 24.7825 56.125 25.9675V44.0725C56.125 46.0825 54.505 47.9125 52.525 48.1525L52.03 48.2125C48.94 48.6175 43.99 50.2525 41.245 51.7675C40.885 51.9775 40.45 52.0675 40 52.0675ZM27.97 24.0775C27.49 24.0775 27.055 24.2425 26.71 24.5575C26.335 24.9025 26.125 25.3975 26.125 25.9375V44.0575C26.125 44.9425 26.89 45.7975 27.745 45.9175L28.195 45.9775C31.57 46.4275 36.745 48.1225 39.745 49.7575C39.88 49.8175 40.075 49.8325 40.15 49.8025C43.15 48.1375 48.355 46.4275 51.745 45.9775L52.255 45.9175C53.11 45.8125 53.875 44.9425 53.875 44.0575V25.9525C53.875 25.3975 53.665 24.9175 53.29 24.5575C52.9 24.2125 52.405 24.0475 51.85 24.0775C51.82 24.0775 51.7 24.0775 51.67 24.0775C48.805 24.3325 44.185 25.8775 41.665 27.4525L41.425 27.6175C40.6 28.1275 39.43 28.1275 38.635 27.6325L38.275 27.4225C35.71 25.8475 31.09 24.3175 28.15 24.0775C28.09 24.0775 28.03 24.0775 27.97 24.0775Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 50.8076C39.385 50.8076 38.875 50.2976 38.875 49.6826V27.1826C38.875 26.5676 39.385 26.0576 40 26.0576C40.615 26.0576 41.125 26.5676 41.125 27.1826V49.6826C41.125 50.3126 40.615 50.8076 40 50.8076Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.625 32.8076H30.25C29.635 32.8076 29.125 32.2976 29.125 31.6826C29.125 31.0676 29.635 30.5576 30.25 30.5576H33.625C34.24 30.5576 34.75 31.0676 34.75 31.6826C34.75 32.2976 34.24 32.8076 33.625 32.8076Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.75 37.3076H30.25C29.635 37.3076 29.125 36.7976 29.125 36.1826C29.125 35.5676 29.635 35.0576 30.25 35.0576H34.75C35.365 35.0576 35.875 35.5676 35.875 36.1826C35.875 36.7976 35.365 37.3076 34.75 37.3076Z",
    fill: "#053CC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1019_131275",
    x: 0,
    y: 0.947266,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1019_131275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1019_131275",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.bc33edfdd5d2588ddd42f48d153ef4de.svg";
export { ForwardRef as ReactComponent };